<template>
  <!-- 页面模板 -->
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="名称" size="small">
              <el-select v-model="listQuery.bankName" placeholder="" style="width:180px" filterable clearable value-key="Projectid">
                <el-option v-for="(item,index) in bankList" :key="index" :label="item.code" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>通知</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="openSendDialog">发送通知</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column prop="taskNum" label="任务编号" min-width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="220">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small">停用</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog :title="type == 'add' ? '添加' : '编辑'" :visible.sync="addVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :inline="true" :model="addForm" :rules="rules" class="" label-width="100px" size="small">
        <el-form-item label="类别:" prop="busiId">
          <el-select v-model="addForm.busiId" placeholder="" style="width:300px" filterable clearable @change="changeBusiId">
            <el-option v-for="(item,index) in busiList" :key="index" :label="item.busiName" :value="item.busiId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板名称:" prop="templateNmae">
          <el-input v-model="addForm.templateNmae" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="优先级:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.priority">
              <el-radio label="1">紧急</el-radio>
              <el-radio label="2">高</el-radio>
              <el-radio label="3">中</el-radio>
              <el-radio label="4">低</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="任务描述:">
          <el-input v-model="addForm.taskDes" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input v-model="addForm.task" size="small" style="width: 300px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="名单附件">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>

        <div>
          <el-form-item label="任务人:">
            <el-radio-group v-model="taskUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="taskUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="taskUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="通知对象:">
            <el-radio-group v-model="noticeUser">
              <el-radio label="项目客服">项目客服</el-radio>
              <el-radio label="项目业务员">项目业务员</el-radio>
              <el-radio label="项目管理员">项目管理员</el-radio>
              <el-radio label="指定人员">指定人员</el-radio>
            </el-radio-group>
            <el-select filterable v-model="noticeUserList" clearable placeholder="" style="width: 240px;margin-left: 15px;" size="small" multiple v-if="noticeUser=='指定人员'">
              <el-option v-for="(item, index) in userList" :key="index" :label="item.username" :value="item.userid"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="通知方式:">
          <el-radio-group v-model="addForm.noticeMethod">
            <el-radio label="1">企微</el-radio>
            <el-radio label="2">短信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态:">
          <div style="width: 300px;">
            <el-radio-group v-model="addForm.enabled">
              <el-radio label="1">启用</el-radio>
              <el-radio label="2">停用</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <div class="info_Item_Title f_form" style="margin-bottom: 10px">
          扩展设置
        </div>
        <div>
          <el-form-item label="任务形式:">
            <el-radio-group v-model="addForm.taskFromat">
              <el-radio label="1">单次任务</el-radio>
              <el-radio label="2">定期重复任务</el-radio>
              <el-radio label="2">多次重复任务</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==1">
          <el-form-item label="任务时限要求:">
            <div class="taskDL">
              <el-radio-group v-model="addForm.taskDeadline">
                <el-radio label="1">无要求</el-radio>
                <el-radio label="2">
                  单日任务： T +
                  <el-input v-model="addForm.taskDeadline2day" size="small" style="width: 80px;"></el-input>
                  日任务，
                  <el-input v-model="addForm.taskDeadline2Hour" size="small" style="width: 80px;"></el-input>
                  时前完成
                </el-radio>
                <el-radio label="3">
                  多日任务：
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="1">
                      <el-date-picker v-model="addForm.taskDeadline31StartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" style="width: 120px;"></el-date-picker>
                      ~
                      <el-date-picker v-model="addForm.taskDeadline31EndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" style="width: 120px;"></el-date-picker>
                      日，截止日
                      <el-input v-model="addForm.taskDeadline31Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                  <div v-if="addForm.taskDeadline==3" style="padding-left: 40px;margin-top: 10px;">
                    <el-radio v-model="addForm.taskDeadline3Type" label="2">
                      T +
                      <el-input v-model="addForm.taskDeadline32day1" size="small" style="width: 80px;"></el-input>
                      ~ T +
                      <el-input v-model="addForm.taskDeadline32day2" size="small" style="width: 80px;"></el-input>
                      截止日
                      <el-input v-model="addForm.taskDeadline32Hour" size="small" style="width: 80px;"></el-input>
                      时前完成
                    </el-radio>
                  </div>
                </el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
        </div>
        <div v-if="addForm.taskFromat==2" style="padding-left: 80px;">
          <el-form-item label="">
            每
            <el-select v-model="addForm.regularlyRepeatingTasks" placeholder="" style="width:80px">
              <el-option label="周" :value="1"></el-option>
              <el-option label="月" :value="2"></el-option>
            </el-select>
            第
            <el-input v-model="addForm.regularlyRepeatingTasksDay" size="small" style="width: 80px;"></el-input>
            日开始
            <el-radio-group v-model="addForm.regularlyRepeatingTaskCompletewithoutAnyDeadline">
              <el-radio label="0">
                T +
                <el-input v-model="addForm.regularlyRepeatingTasksAddDay" size="small" style="width: 80px;"></el-input>
                日
                <el-input v-model="addForm.regularlyRepeatingTasksHour" size="small" style="width: 80px;"></el-input>
                时前完成
              </el-radio>
              <el-radio label="1">不限日期完成</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 发送通知 -->
    <el-dialog title="发送通知" :visible.sync="sendVisible" width="700px" class="res_dialog enter_dialog" :close-on-click-modal="false">
      <div class="send_notice_dialog">
        <div class="notice_section">
          <span class="section_label">已接受人：</span>
          <span class="recipient_count">{{ sendForm.recipientList.length }}人</span>
          <el-button type="text" size="small" @click="addRecipients">添加</el-button>
          <el-button type="text" size="small" @click="clearRecipients">清空</el-button>
          <div class="recipient_names" v-if="sendForm.recipientList.length > 0">
            {{ recipientNamesText }}
          </div>
        </div>

        <div class="notice_section">
          <span class="section_label">发送渠道：</span>
          <el-checkbox v-model="sendForm.channels.sms" @change="onChannelChange">
            短信，选择发送签名：
            <el-select v-model="sendForm.smsSignature" placeholder="请选择" size="small" style="width:180px;margin-left:8px;" :disabled="!sendForm.channels.sms">
              <el-option v-for="item in signatureList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-checkbox>
          <el-checkbox v-model="sendForm.channels.wechat" @change="onChannelChange">
            微信公众号：
            <el-select v-model="sendForm.wechatAccount" placeholder="请选择" size="small" style="width:160px;margin-left:8px;" :disabled="!sendForm.channels.wechat">
              <el-option v-for="item in wechatAccountList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-checkbox>
        </div>

        <div class="notice_section" v-if="sendForm.channels.sms">
          <span class="section_label">短信模板：</span>
          <el-select v-model="sendForm.smsCategory" placeholder="请选择类别" size="small" style="width:140px;" @change="onSmsCategoryChange">
            <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select v-model="sendForm.smsTemplate" placeholder="请选择模板" size="small" style="width:180px;margin-left:8px;">
            <el-option v-for="item in templateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div class="notice_section" v-if="sendForm.channels.wechat">
          <span class="section_label">公众号模板：</span>
          <el-select v-model="sendForm.oaCategory" placeholder="请选择类别" size="small" style="width:140px;" @change="onOaCategoryChange">
            <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select v-model="sendForm.oaTemplate" placeholder="请选择模板" size="small" style="width:180px;margin-left:8px;">
            <el-option v-for="item in templateOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div class="notice_section">
          <el-checkbox v-model="sendForm.showPosition">
            岗位：
            <el-radio-group v-model="sendForm.positionType" size="small">
              <el-radio label="auto">按应聘岗位</el-radio>
              <el-radio label="custom">自定义：</el-radio>
            </el-radio-group>
            <el-input v-model="sendForm.positionCustom" size="small" style="width:160px;margin-left:8px;" :disabled="sendForm.positionType !== 'custom'"></el-input>
          </el-checkbox>
        </div>

        <div class="notice_section">
          <el-checkbox v-model="sendForm.showReportDate">
            报到日：
            <el-date-picker v-model="sendForm.reportDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small" style="width:160px;margin-left:8px;" :disabled="!sendForm.showReportDate"></el-date-picker>
          </el-checkbox>
        </div>

        <div class="notice_section">
          <span class="section_label">地点（选填）：</span>
          <el-input v-model="sendForm.location" size="small" style="width:300px;" placeholder="请输入地点"></el-input>
        </div>

        <div class="notice_section">
          <span class="section_label">发送内容预览：</span>
          <div class="preview_tabs">
            <span class="preview_tab" :class="{active: previewTab === 'sms'}" v-if="sendForm.channels.sms" @click="previewTab = 'sms'">短信预览</span>
            <span class="preview_tab_sep" v-if="sendForm.channels.sms && sendForm.channels.wechat">|</span>
            <span class="preview_tab" :class="{active: previewTab === 'wechat'}" v-if="sendForm.channels.wechat" @click="previewTab = 'wechat'">公众号预览</span>
          </div>
          <div class="preview_content" v-if="previewTab === 'sms' && sendForm.channels.sms">
            <pre class="preview_text">{{ smsPreviewText }}</pre>
          </div>
          <div class="preview_content" v-if="previewTab === 'wechat' && sendForm.channels.wechat">
            <div class="oa_preview">
              <div class="oa_title">标题：录用通知书（张伟 先生/女士）</div>
              <div class="oa_field">岗位：XXXXX</div>
              <div class="oa_field">报到日：2026-0901</div>
              <div class="oa_field">地点：XXXXXXXXXXXXX</div>
              <div class="oa_actions">
                <a class="oa_link" @click.prevent>点击确认接受</a>
                <a class="oa_link" @click.prevent style="margin-left:20px;">点击拒绝</a>
              </div>
            </div>
          </div>
        </div>

        <div class="notice_section">
          <span class="section_label">发送时间：</span>
          <el-radio-group v-model="sendForm.sendTimeType" size="small">
            <el-radio label="immediate">立即发送</el-radio>
            <el-radio label="scheduled">定时发送：</el-radio>
          </el-radio-group>
          <template v-if="sendForm.sendTimeType === 'scheduled'">
            <el-date-picker v-model="sendForm.scheduleDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small" style="width:150px;margin-left:8px;"></el-date-picker>
            <el-time-picker v-model="sendForm.scheduleTime" placeholder="选择时间" size="small" style="width:150px;margin-left:8px;" value-format="HH:mm:ss"></el-time-picker>
          </template>
        </div>

        <div class="notice_warning">
          注意：发送录用通知后将产生法律效力，请确认后再发送！
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSendNotice" :loading="sendLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          bankName: '',
          accountName: '',
          accountNo: ''
        },
        addForm: {

        },
        addVisible: false,
        sendVisible: false,
        isBtnLoading: false,
        sendLoading: false,
        sendForm: {
          recipientList: [],
          channels: {
            sms: false,
            wechat: false
          },
          smsSignature: '',
          wechatAccount: '',
          smsCategory: '',
          smsTemplate: '',
          oaCategory: '',
          oaTemplate: '',
          showPosition: false,
          positionType: 'auto',
          positionCustom: '',
          showReportDate: false,
          reportDate: '',
          location: '',
          sendTimeType: 'immediate',
          scheduleDate: '',
          scheduleTime: ''
        },
        signatureList: ['宁波杰博人力'],
        wechatAccountList: ['杰博股份'],
        categoryOptions: ['录用通知', '入职提醒', '合同到期'],
        templateOptions: ['录用通知+杰小职', '录用通知+杰博', '入职提醒+杰小职'],
        previewTab: 'sms',
        selectedRows: [],

        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        projectList: [], //项目列表

        rules: {
          bankName: {
            required: true,
            message: '请选择银行',
            trigger: 'change'
          },

        },
      }
    },
    computed: {
      recipientNamesText() {
        const names = this.sendForm.recipientList.map(r => r.name || r).join('，')
        if (names.length > 50) {
          return names.substring(0, 50) + '....'
        }
        return names
      },
      smsPreviewText() {
        if (!this.sendForm.channels.sms) return ''
        const sig = this.sendForm.smsSignature || '宁波杰博人力'
        return `【${sig}】尊敬的${this.sendForm.recipientList.length > 0 ? '张伟' : 'XXX'}，您好！\n很荣幸通知您已被我司关联公司录用，请点击链接进行入职登记：https://hr.xx.com/offer/verify?token=xx`
      }
    },
    created() {
      this.getList();
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetBusiBankTaskSettingList').then(res => {
          if (res.status === 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleSelectionChange(rows) {
        this.selectedRows = rows;
      },
      openSendDialog() {
        if (this.selectedRows.length === 0) {
          this.$message.warning('请先选择候选人');
          return;
        }
        this.sendForm.recipientList = this.selectedRows.map(r => ({
          id: r.id,
          name: r.taskNum || '候选人'
        }));
        this.sendVisible = true;
      },
      addRecipients() {
        this.$message.info('添加候选人功能待接入');
      },
      clearRecipients() {
        this.sendForm.recipientList = [];
      },
      onChannelChange() {
        if (!this.sendForm.channels.sms) {
          this.sendForm.smsCategory = '';
          this.sendForm.smsTemplate = '';
        }
        if (!this.sendForm.channels.wechat) {
          this.sendForm.oaCategory = '';
          this.sendForm.oaTemplate = '';
        }
        if (this.sendForm.channels.sms && !this.sendForm.channels.wechat) {
          this.previewTab = 'sms';
        } else if (this.sendForm.channels.wechat && !this.sendForm.channels.sms) {
          this.previewTab = 'wechat';
        }
      },
      onSmsCategoryChange() {
        this.templateOptions = this.sendForm.smsCategory
          ? ['录用通知+杰小职', '录用通知+杰博', '入职提醒+杰小职']
          : [];
        this.sendForm.smsTemplate = '';
      },
      onOaCategoryChange() {
        this.templateOptions = this.sendForm.oaCategory
          ? ['录用通知+杰小职', '录用通知+杰博', '入职提醒+杰小职']
          : [];
        this.sendForm.oaTemplate = '';
      },
      confirmSendNotice() {
        if (!this.sendForm.channels.sms && !this.sendForm.channels.wechat) {
          this.$message.warning('请至少选择一种发送渠道');
          return;
        }
        if (this.sendForm.channels.sms && !this.sendForm.smsSignature) {
          this.$message.warning('请选择短信发送签名');
          return;
        }
        if (this.sendForm.channels.wechat && !this.sendForm.wechatAccount) {
          this.$message.warning('请选择微信公众号');
          return;
        }
        if (this.sendForm.sendTimeType === 'scheduled') {
          if (!this.sendForm.scheduleDate || !this.sendForm.scheduleTime) {
            this.$message.warning('请选择定时发送的日期和时间');
            return;
          }
        }
        this.$confirm('发送录用通知后将产生法律效力，确认发送？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendLoading = true;
          setTimeout(() => {
            this.sendLoading = false;
            this.$message.success('通知发送成功！');
            this.sendVisible = false;
          }, 1000);
        }).catch(() => {});
      },
      editHandle(row) {
        this.type = 'edit'
        this.addForm = {}
        this.isBtnLoading = false;
        this.addVisible = true;
      },
      confirmAdd() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addForm, 'AddUpdataBusiBankTaskSetting').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.addVisible = false;
                this.isBtnLoading = false;
                this.$message.success('添加成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      stopHandel(status) {},
      delHandle(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataBusiBankTaskSetting').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('删除成功！')
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .timeTitle {
    padding: 0 20px;
  }

  .timeItemTile {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .send_notice_dialog {
    padding: 10px 0;
  }

  .notice_section {
    margin-bottom: 16px;
    line-height: 32px;
    font-size: 14px;
  }

  .section_label {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
    color: #606266;
  }

  .recipient_count {
    color: #409EFF;
    font-weight: bold;
    margin-right: 8px;
  }

  .recipient_names {
    margin-top: 4px;
    padding-left: 110px;
    color: #606266;
    line-height: 1.6;
  }

  .preview_tabs {
    display: inline-block;
    margin-left: 110px;
  }

  .preview_tab {
    cursor: pointer;
    color: #409EFF;
    padding: 0 4px;
  }

  .preview_tab.active {
    color: #303133;
    font-weight: bold;
  }

  .preview_tab_sep {
    color: #dcdfe6;
    margin: 0 4px;
  }

  .preview_content {
    margin-top: 8px;
    margin-left: 110px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 12px;
    max-width: 450px;
  }

  .preview_text {
    white-space: pre-wrap;
    font-family: inherit;
    font-size: 13px;
    color: #303133;
    margin: 0;
  }

  .oa_preview {
    font-size: 13px;
    color: #303133;
  }

  .oa_title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  .oa_field {
    margin-bottom: 4px;
  }

  .oa_actions {
    margin-top: 10px;
  }

  .oa_link {
    color: #409EFF;
    cursor: pointer;
    text-decoration: underline;
  }

  .notice_warning {
    margin-top: 20px;
    padding: 10px 15px;
    background: #fef0f0;
    border: 1px solid #fbc4c4;
    border-radius: 4px;
    color: #f56c6c;
    font-size: 13px;
    text-align: center;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>